import * as React from 'react'

export const reactMajor = parseInt(React.version, 10)
